import {hasFeature} from '../core/service/env.js';
import {christmas} from './christmas';

class Games {}

const special = !hasFeature('special') ? null : {christmas};

export {special};
